// extracted by mini-css-extract-plugin
export default {"SaucesList":"SaucesList_SaucesList__3-bOk","SaucesList__item":"SaucesList_SaucesList__item__gmC3B","SaucesList__check":"SaucesList_SaucesList__check__PFdvd"};